import React from "react";
import logo from "../assets/icons/black full logo.svg";

const MainLoader = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <img src={logo} alt="Logo" className="w-32 lg:w-40 animate-pulse" />
    </div>
  );
};

export default MainLoader;